export const WORKSPACE_PULSE_PROJECT_ACCESS_TOAST = 'Ask the project admin to add you to this project.';

export const WORKSPACE_PULSE_ACCESS_TOAST =
    'You do not have access to Workspace Pulse for this workspace. Ask your workspace admin to add you as an email recipient.';
